import AccreditedRegisterComposer from '../../../composers/AccreditedRegisterComposer';

export default function AccreditedRegisterPage(): JSX.Element {
  return <AccreditedRegisterComposer />;
}
